export default __webpack_public_path__ + "static/media/moralis.99b22d42.png";